<a href="/diagnostics">Diagnostics</a>
<a target="_blank" href="https://helpdesk.autoform.com/servicedesk/customer/user/login?destination=plugins/servlet/desk">HelpDesk</a>
<a target="_blank" href="https://www.autoform.com/{{translationService.getLanguage()}}/imprint/">Impressum</a>

<span>&copy; {{ date | date: 'yyyy' }} AutoForm Engineering GmbH</span>
